import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/core/utilities.service';

type NotifyType = 'success' | 'info' | 'error' | 'warning' | 'none';
type NotifyOptions = {
  content?: String;
  title?: String;
  type?: NotifyType;
  icon?: String;
  position?: String;
  delay?: Number;
  showTimeBar?: Boolean;
};

@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss'],
  host: {
    class: 'toast-container fixed p-3',
    style: 'z-index: 1100',
  },
})
export class NotifyComponent {
  constructor(public utils: UtilitiesService) {}

  toasts = [];

  ngOnDestroy(): void {
    this.toasts = [];
  }

  show(
    messages: string | object | string[],
    options: NotifyOptions = {},
    translateString = true
  ) {
    console.log(this.toasts);

    if (typeof messages === 'string') messages = [messages];

    const msgList = [];
    if (messages) {
      Object.keys(messages).forEach((msgKey) => {
        let message = `${messages[msgKey]}`;
        if (translateString) message = this.utils.translate(message);

        console.log('message', { message: message });
        msgList.push(message);
      });
    }

    messages = msgList.join(`\n`);

    options.content = messages;
    this.toasts.push({ ...options });
  }

  showSuccess(
    messages,
    title: string | null = null,
    duration: number | null = null,
    translateString = true
  ) {
    this.show(
      messages,
      {
        title: title,
        type: 'success',
        delay: duration,
      },
      translateString
    );
  }

  showInfo(
    messages,
    title: string | null = null,
    duration: number | null = null,
    translateString = true
  ) {
    this.show(
      messages,
      {
        title: title,
        type: 'info',
        delay: duration,
      },
      translateString
    );
  }

  showError(
    messages,
    title: string | null = null,
    duration: number | null = null,
    translateString = true
  ) {
    this.show(
      messages,
      {
        title: title,
        type: 'error',
        delay: duration,
      },
      translateString
    );
  }

  showWarning(
    messages,
    title: string | null = null,
    duration: number | null = null,
    translateString = true
  ) {
    this.show(
      messages,
      {
        title: title,
        type: 'warning',
        delay: duration,
      },
      translateString
    );
  }

  remove(toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  ngOnInit() {
    this.utils.notify = this;
  }
}
